import {RemoteGetServicePointsUfs} from 'data/usecases/private/service-points/remote-get-service-points-ufs';
import {GetServicePointsUfs} from 'domain/usecases/private/service-points/get-service-points-ufs';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ServicePointsEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetServicePointsUfs = (): GetServicePointsUfs =>
	new RemoteGetServicePointsUfs(
		makeBFFApiUrl(ServicePointsEndpoints.getServicePointsUfs),
		makeAuthorizeHttpClientDecorator(),
	);
